import api from './api';

// Serviço para operações de funcionários

export const fetchFuncionarios = async ({ page = 1, limit = 10, search = '', filters = {} } = {}) => {
  const params = { page, limit };
  if (search) params.nome = search;
  Object.assign(params, filters);
  const resp = await api.get('/funcionarios', { params });
  return resp.data;
};

export const fetchFuncionarioById = async (id) => {
  const resp = await api.get(`/funcionarios/${id}`);
  console.log('fetchFuncionarioById response:', resp);
  return resp.data.data || resp.data;
};

export const createFuncionario = async (funcionario) => {
  const resp = await api.post('/funcionarios', funcionario);
  return resp.data.data || resp.data;
};

export const updateFuncionario = async (id, funcionario) => {
  const resp = await api.put(`/funcionarios/${id}`, funcionario);
  return resp.data;
};

export const deleteFuncionario = async (id) => {
  const resp = await api.delete(`/funcionarios/${id}`);
  return resp.data;
};
